import { Box, WizardStepRenderParams } from '@factorialco/deprecated-design-system'
import { BankingAccountLegalEntityFragment } from 'generated/resources/graphql'

import SelectField from 'modules/core/components/SelectField'
import { useUnsafeCallback } from 'modules/core/hooks/useCallback'
import i18n from 'modules/core/lib/i18n'

import { defaultBankNumberFormat } from 'modules/banking/lib/bankAccountNumbersHelpers'

import { WizardManualAccountData } from '../../types'
import { WizardStepLayout } from '../WizardStepLayout'

interface Props {
  legalEntities: BankingAccountLegalEntityFragment[]
}

export const LegalEntityWizardStep = ({
  data,
  onDataChanged,
  legalEntities,
}: WizardStepRenderParams<WizardManualAccountData> & Props) => {
  const handleFieldChanged = useUnsafeCallback(
    (newLegalEntityId: string) => {
      const selectedLegalEntity = legalEntities.find(
        (legalEntity) => legalEntity.id.toString() == newLegalEntityId
      )
      onDataChanged({
        ...data,
        legalEntityId: newLegalEntityId ? Number(newLegalEntityId) : null,
        currency: selectedLegalEntity?.currency || data.currency,
        accountNumberType: selectedLegalEntity
          ? defaultBankNumberFormat(selectedLegalEntity.country)
          : data.accountNumberType,
        country: selectedLegalEntity?.country.toLocaleUpperCase() ?? data.country,
      })
    },
    [data, onDataChanged, legalEntities]
  )

  return (
    <WizardStepLayout
      title={i18n.t('banking.accounts.new_wizard.step_1.title')}
      subtitle={i18n.t('banking.accounts.new_wizard.step_1.subtitle')}
    >
      <Box style={{ width: '500px' }} flexDirection="row" gap="s48">
        <Box width="full" flexNoShrink flexDirection="column" gap="s8">
          <SelectField
            label={i18n.t('banking.accounts.side_panel.legal_entity')}
            mandatory
            none={i18n.t('common.select')}
            defaultValue={data.legalEntityId?.toString()}
            options={legalEntities.map((legalEntity) => ({
              label: legalEntity.legalName || '',
              value: legalEntity.id,
            }))}
            onChange={handleFieldChanged}
          />
        </Box>
      </Box>
    </WizardStepLayout>
  )
}
